import React from "react";

const SponsorshipInfo = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-6 space-y-20 scroll-smooth">
      {/* My Involvement */}
      <section
        id="my-involvement"
        className="bg-white rounded-lg shadow-md p-8 border border-[#0077C8]"
      >
        <h1 className="text-4xl font-extrabold text-[#0077C8] mb-4 text-center">
          My Involvement as a Sponsor
        </h1>
        <p className="text-lg text-gray-700 mb-6 text-center max-w-2xl mx-auto">
          Sponsoring a child means you build a meaningful connection that encourages and empowers them. Your support brings hope and practical help to a child who needs it most.
        </p>
        <div className="bg-[#F0F8FF] rounded-lg p-6 border border-[#0077C8]">
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">✓</span>
              <span>Provide financial support that meets their essential needs.</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">✓</span>
              <span>Exchange letters and photos to nurture a personal relationship.</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">✓</span>
              <span>Receive regular progress reports about their development.</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">✓</span>
              <span>Know that you’re helping their family and community thrive.</span>
            </li>
          </ul>
        </div>
      </section>

      {/* How to Sponsor */}
      <section
        id="how-to-sponsor"
        className="bg-white rounded-lg shadow-md p-8 border border-[#0077C8]"
      >
        <h2 className="text-4xl font-extrabold text-[#0077C8] mb-4 text-center">
          How to Become a Sponsor
        </h2>
        <p className="text-lg text-gray-700 mb-8 text-center max-w-2xl mx-auto">
          Sponsoring a child is simple, life-changing, and starts with just a few meaningful steps. Your commitment brings hope and opportunity.
        </p>
        <div className="bg-[#F0F8FF] rounded-lg p-6 border border-[#0077C8] mb-6">
          <ol className="list-decimal list-inside space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="font-bold text-[#0077C8] mr-2">1.</span>
              <span>Browse children in need and select one you feel drawn to support.</span>
            </li>
            <li className="flex items-start">
              <span className="font-bold text-[#0077C8] mr-2">2.</span>
              <span>Complete the secure sponsorship form with your details.</span>
            </li>
            <li className="flex items-start">
              <span className="font-bold text-[#0077C8] mr-2">3.</span>
              <span>Set up your preferred payment method.</span>
            </li>
            <li className="flex items-start">
              <span className="font-bold text-[#0077C8] mr-2">4.</span>
              <span>Start building a relationship through letters, photos, and updates.</span>
            </li>
          </ol>
        </div>
        <p className="text-gray-700 text-center">
          If you have questions, please{" "}
          <a
            href="#contact-sponsorship"
            className="text-[#0077C8] underline hover:opacity-80"
          >
            contact us
          </a>. Together, we can release children from poverty in Jesus’ name.
        </p>
      </section>

      {/* How is the Money Used */}
      <section
        id="funds-usage"
        className="bg-white rounded-lg shadow-md p-8 border border-[#0077C8]"
      >
        <h2 className="text-4xl font-extrabold text-[#0077C8] mb-4 text-center">
          How is the Money Used?
        </h2>
        <p className="text-lg text-gray-700 mb-8 text-center max-w-2xl mx-auto">
          Your sponsorship contributions are carefully managed to maximize impact and transparency. We ensure your support goes exactly where it’s needed most.
        </p>
        <div className="bg-[#F0F8FF] rounded-lg p-6 border border-[#0077C8]">
          <ul className="space-y-4 text-gray-700">
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">50%</span>
              <span>Supports school operations: meals, teacher salaries, and maintenance.</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#0077C8] font-bold mr-2">50%</span>
              <span>Provided directly to the child’s family or guardians for daily needs.</span>
            </li>
          </ul>
        </div>
        <p className="text-gray-700 text-center mt-6">
          We are committed to accountability, and you will receive reports showing how your support is used.
        </p>
      </section>

      {/* Contact Someone About Sponsorship */}
      <section
        id="contact-sponsorship"
        className="bg-white rounded-lg shadow-md p-8 border border-[#0077C8]"
      >
        <h2 className="text-4xl font-extrabold text-[#0077C8] mb-4 text-center">
          Speak to Somebody About Sponsoring a Child
        </h2>
        <p className="text-lg text-gray-700 mb-8 text-center max-w-2xl mx-auto">
          We’d love to answer your questions and help you start your sponsorship journey. Reach out to us in Kenya or the United Kingdom—we’re here for you!
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-[#F0F8FF] rounded-lg p-6 border border-[#0077C8]">
            <h3 className="text-2xl font-bold text-[#0077C8] mb-2 text-center">Kenya Office</h3>
            <p className="text-gray-800 text-center">Michael Otsieno Wanzala</p>
            <p className="text-gray-700 text-center mt-2">
              Email:{" "}
              <a
                href="mailto:admin@gmail.com"
                className="text-[#0077C8] underline hover:opacity-80"
              >
                admin@gmail.com
              </a>
            </p>
          </div>
          <div className="bg-[#F0F8FF] rounded-lg p-6 border border-[#0077C8]">
            <h3 className="text-2xl font-bold text-[#0077C8] mb-2 text-center">United Kingdom Office</h3>
            <p className="text-gray-800 text-center">Lynne White</p>
            <p className="text-gray-700 text-center mt-2">
              Email:{" "}
              <a
                href="mailto:jeaandlwhite@yahoo.co.uk"
                className="text-[#0077C8] underline hover:opacity-80"
              >
                jeaandlwhite@yahoo.co.uk
              </a>
            </p>
          </div>
        </div>
        <p className="mt-8 text-gray-700 text-center text-2xl">
          We look forward to hearing from you!
        </p>
      </section>
    </div>
  );
};

export default SponsorshipInfo;
